import React                   from 'react';
import PropTypes               from 'prop-types';
import PreviewPictures         from "./Base/Preview/PreviewPictures";
import {TileDisplayConfigType} from "../Grid2";
import HoverContainer          from "./Base/HoverContainer";
import ReloadHelper            from "../../../utils/ReloadHelper";
import TVSeriesTileFooter      from "./TVSeriesTileFooter";

const TVSeriesTile = props => {
	const data          = props.data;
	const displayConfig = props.displayConfig;
	const linkUrl       = data.linkVX;
	const onClick       = e => ReloadHelper.reload(linkUrl, e);

	return (
		<a className={'grid-2__tile__type-tv-series'} href={linkUrl} onClick={onClick}>
			<HoverContainer>
				<PreviewPictures
					staticItem={{
						id:          1337,
						aspectRatio: 0.79,
						images:      [{size: 'w320', url: data.previewImgUrl}, {size: 'w640', url: data.previewImgUrl}],
					}}
					showPlayIconOnHover={false}
					displayConfig={displayConfig}
					lazyImageLoading={props.lazyImageLoading}
				/>
				<TVSeriesTileFooter data={data} displayConfig={displayConfig} />
			</HoverContainer>
		</a>
	);
};

TVSeriesTile.propTypes = {
	data:             PropTypes.object.isRequired, // VXQL TV Series type
	displayConfig:    TileDisplayConfigType.isRequired,
	lazyImageLoading: PropTypes.bool,
};

TVSeriesTile.defaultProps = {
	lazyImageLoading: false,
};

export default TVSeriesTile;
